import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createStaticVNode("<g fill=\"#69788A\" clip-path=\"url(#clip0_38_6959)\"><path d=\"m17.578 8.06-5.022-5.03a.755.755 0 0 0-1.06 0c-.29.29-.29.77 0 1.06l5.022 5.03c.29.29.77.29 1.06 0s.29-.77 0-1.06m-6.082-5.03L6.473 8.06c-.29.29-.29.77 0 1.06s.77.29 1.06 0l5.023-5.03c.29-.29.29-.77 0-1.06a.755.755 0 0 0-1.06 0m-.22.53v12.57c0 .41.34.75.75.75s.75-.34.75-.75V3.56c0-.41-.34-.75-.75-.75s-.75.34-.75.75\"></path><path d=\"M2.06 16.31v1.82c0 1.69 1.361 3.05 3.052 3.05h13.776c1.68 0 3.051-1.37 3.051-3.05v-1.8c0-.41-.34-.75-.75-.75s-.75.34-.75.75v1.8c0 .86-.69 1.55-1.551 1.55H5.102c-.85 0-1.54-.69-1.55-1.55v-1.82c0-.41-.34-.75-.75-.75-.411 0-.751.34-.751.75z\"></path></g><defs><clipPath id=\"clip0_38_6959\"><path fill=\"#fff\" d=\"M0 0h24v24H0z\"></path></clipPath></defs>", 2)
  ]))]))
}
export default { render: render }